import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Zach did a fantastic job sealcoating our driveway and repairing a deep crack. The finished work looks brand new.",
    name: "Verified Google Review",
    service: "Sealcoating",
  },
  {
    quote:
      "In short — they did a terrific job, at an excellent price. Crew was professional from start to finish.",
    name: "Verified Google Review",
    service: "Property Care",
  },
  {
    quote:
      "Our driveway needed extensive work, and the crew handled everything with care. Couldn't be happier.",
    name: "Verified Google Review",
    service: "Driveway Restoration",
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-[var(--rr-surface)] border-y border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="reveal">
            <p className="overline">What clients say</p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-semibold tracking-tighter text-white">
              5.0 on Google.
              <br />
              <span className="text-[var(--rr-text-muted)]">Every single time.</span>
            </h2>
          </div>
          <div className="reveal flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-[var(--rr-accent)] text-[var(--rr-accent)]" />
              ))}
            </div>
            <span className="text-sm text-[var(--rr-text-muted)]">
              <span className="font-semibold text-white">5.0</span> · 11 reviews
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className="reveal card-lift relative bg-[var(--rr-bg)] border border-white/5 rounded-2xl p-7 md:p-8"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <Quote className="h-7 w-7 text-[var(--rr-primary)] opacity-50" />
              <p className="mt-5 text-[17px] leading-relaxed text-white/90">
                "{r.quote}"
              </p>
              <div className="mt-7 pt-5 border-t border-white/5 flex items-center justify-between">
                <div>
                  <div className="text-sm font-semibold text-white">{r.name}</div>
                  <div className="text-xs text-[var(--rr-text-muted)] mt-0.5">
                    {r.service}
                  </div>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star
                      key={j}
                      className="h-3.5 w-3.5 fill-[var(--rr-accent)] text-[var(--rr-accent)]"
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
